import { Injectable, Inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { HttpHeaders } from "@angular/common/http";

var httpOptions = {
  headers: new HttpHeaders({ "Content-Type": "application/json" }),
};


@Injectable({
  providedIn: 'root'
})
export class MateriaComentarioRespostaService {

  private url = "api/materiacomentarioresposta";
  constructor(private http: HttpClient, @Inject("BASE_URL") baseUrl: string) {
    this.url = baseUrl + this.url;
  }

  getToken(): string {
    var tokenJson = JSON.parse(localStorage.getItem('currentUser') || '');
    return tokenJson.token;
  }


  get(): Observable<any> {
    const apiurl = `${this.url}`;
    return this.http.get<any>(apiurl);
  }

  getbyId(id: number): Observable<any> {
    const apiurl = `${this.url}/GetByMateriaComentarioId/${id}`;
    return this.http.get<any>(apiurl);
  }


  post(materiacomentarioresposta:any): Observable<any> {
    const apiurl = `${this.url}`;
    return this.http.post<any>(apiurl, materiacomentarioresposta,{
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getToken()}`,
      },
    });
  }

  getCountByComentarioId(idComentario: number): Observable<any> {
    const apiurl = `${this.url}/GetCountByMateriaComentarioId/${idComentario}`;
    return this.http.get<any>(apiurl);
  }
}
